import {LOAD_WATCHTOWER_SUCCESS} from './actions';

export const watchtower = (state = null, action) => {
  switch (action.type) {
    case LOAD_WATCHTOWER_SUCCESS:
      return action.value.watchtower;
    default:
      return state;
  }
};
